var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDoubleForward = function SvgArrowDoubleForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84668 10.0002L4.72168 5.97274L5.90001 4.82227L11.2033 10.0002L5.90001 15.1782L4.72168 14.0277L8.84668 10.0002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9209 10.0002L8.7959 5.97274L9.97423 4.82227L15.2776 10.0002L9.97423 15.1782L8.7959 14.0277L12.9209 10.0002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgArrowDoubleForward;